<template>
  <div class="column">
    <div class="box">
      <div class="level">
        <div class="level-left">
        </div>

        <div class="level-right">
          <b-dropdown position="is-bottom-left">
            <a slot="trigger">block</a>

            <div class="dropdown-item" style="min-width: 300px;">
              <div>
                <b-field>
                  <b-input v-model="ip"></b-input>
                </b-field>

                <b-field class="right">
                  <b-button @click="add">block</b-button>
                </b-field>
              </div>
            </div>
          </b-dropdown>
        </div>
      </div>

      <b-table class="is-middle" :data="ips">
        <template slot-scope="props">

          <b-table-column custom-key="name" label="id">{{ props.row.id }}</b-table-column>

          <b-table-column label="IP">
            <strong>{{ props.row.ip }}</strong>
          </b-table-column>

          <b-table-column label="Blocked Date">
            <strong>{{ props.row.created_at | dateTime }}</strong>
          </b-table-column>

          <b-table-column custom-key="actions">
            <div class="is-pulled-right">
              <button class="button is-white" @click="remove(props.row)">
                <b-icon icon="close" size="is-small"></b-icon>
              </button>
            </div>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>


<script>

export default {

  data() {
    return {
      ips : this.load(),
      ip : null
    }
  },

  mounted() {
    this.load();
  },

  computed: {
    pageTitle() {
      return "Slider - " + this.$route.params.id;
    }
  },

  methods: {
    load() {
      this.$http
        .get("api/restricted-ip")
        .then(response => {
          this.ips = response.data.data;
        });
    },

    add() {
      console.log(this.ip);

      this.$http
        .post("api/restricted-ip", {
          ip: this.ip
        })
        .then(response => {
          this.$buefy.toast.open(response.data.message);
          this.load();
          this.close();
        });
    },

    remove(ip) {
      this.$http
        .delete(
          `api/restricted-ip/${ip.id}`
        )
        .then(() => {
          this.load();
        });
    }
  }
};
</script>
